export default {
  name: '',
  description: '',
  endDate: '',
  endText: '',
  introText: '',
  isAnonymous: false,
  startDate: '',
  employeeSurveys: [],
  questionsAttributes: [
    {
      questionType: 'selection',
      responseFormat: 'simple',
      label: '',
      description: '',
      required: false,
      position: 1,
      questionChoicesAttributes: [
        { label: '', position: 1 },
        { label: '', position: 2 }
      ]
    }
  ]
};
